import { Component, OnInit } from '@angular/core';
import { BpgEventsService } from "../../bpg-events/bpg-events.service";
import { ActivatedRoute, NavigationEnd } from "@angular/router";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService, Employee, SurveyQuestion, SurveyAnswer, TakeSurvey, SurveyMaster, SuveyTakenByUserDTO } from "../../bpg-common/services/data.services";

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-take-survey',
  templateUrl: './take-survey.component.html',
  styleUrls: ['./take-survey.component.css']
})
export class TakeSurveyComponent implements OnInit {
  selectedAnswer: any[] = [];
  textAnswer: any[] = [];
  comments: any[] = [];
  selectedQuestion: any[] = [];
  data: any;
  selectedInterest: any;
  questions: any[] = [];
  questionsText: any[] = [];
  questionsSelect: any[] = [];
  length: any;

  answers: any[] = [];
  questionAnswer: any[] = [];
  questionsAndAnswersModel = [];
  takeServeyData: any;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertDuplicateSurvey: boolean;
  alertNoSurvey: boolean;
  noDataFound: boolean;

  /*From Data Service*/
  employee: Employee = new Employee();
  surveyQuestion: SurveyQuestion = new SurveyQuestion();
  surveyAnswer: SurveyAnswer = new SurveyAnswer();
  takeSurvey: TakeSurvey = new TakeSurvey();
  SurveyMaster: SurveyMaster = new SurveyMaster();
  SuveyTakenByUserDTO: SuveyTakenByUserDTO = new SuveyTakenByUserDTO();

  takeSurveyList: TakeSurvey[];
  takeSurveyCopy: any;
  response: any;
  /*For confirmation*/
  method: any;
  msg1: any;
  msg2: any;

  /* event Details */
  eventFromNavigate: any;
  eventDetails: any;
  eventId: any;
  eventDTO: any;

  /* login Details */
  loginDetails: any;

  /* User Details */
  userId: any;
  optionalUserName:any;

  /* Survey Details */
  surveyId: any;
  surveyLaunchAdmin: any;

  IsSurveyAlreadyTaken: boolean;
  public DisableRadio: boolean = false;
  public DisableText: boolean = false;

  eventCount:any;

  linkEventId:any;
  linkId:any;
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;

  nameShow:Boolean = false;

  /**
  * @class TakeSurveyComponent
  * @constructor
  */
  constructor(private eventService: BpgEventsService,
    private spinner: Ng4LoadingSpinnerService,
    private dataDto: DataService,
    private router: Router,
    private route: ActivatedRoute,
    
    private environment : EnvironmentConfiguration) { }

  ngOnInit() {
    
    if(this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod'){
   if(localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined ){
        this.router.navigate(['/log-out']);
      }}

    this.spinner.show();

    localStorage.setItem("landingPage","takeSurvey");

    this.eventDetails = JSON.parse(sessionStorage.getItem("eventDetails"));
   
    this.route.params.subscribe(params => {

     this.linkId=  localStorage.getItem("paramaterId");
     if((this.linkId) !=null)
         {
           this.linkEventId = localStorage.getItem("paramaterId")
         }
        localStorage.setItem("paramaterId",params.id)

      this.eventFromNavigate = {

        "eventId": (params.id) ? params.id :this.linkEventId
       // "eventId": (params.id) ? params.id :this.eventDetails.eventId
      }

      this.eventId =  this.eventFromNavigate.eventId; 

    })
    this.loginDetails = JSON.parse(localStorage.getItem("loginData"));
    this.getSurveyId();
    if(this.loginDetails != null ){
      this.userId = this.loginDetails.userId;
      this.optionalUserName = this.loginDetails.userFirstName+" "+this.loginDetails.userLastName;
    }
    else{   
      //this.router.navigate(['/login']);
      localStorage.setItem("eventIdforSurvey",this.eventId);
      localStorage.setItem("eventId",this.eventId);
    }
    this.questions = [];
    this.takeSurveyList = [];

  }

  getSurveyId() {
    this.timeOutError = false;
    this.eventDTO = {
      "id": this.eventId
    }
    this.eventService.getSurveyId(this.eventDTO).subscribe(data => {
      this.surveyId = data.surveyId;
      this.surveyLaunchAdmin = data.surveyLaunchAdmin;
      this.listQuestionAnswers();
      this.suveyTakenByUser(this.surveyId);
    },
      err => {
        this.spinner.hide();
        console.log(JSON.stringify(err.value.message));
        if(err.value.statusText == ConstantValues.unknownError){
                    this.timeOutError = true;
                  }
      });
  
  }

  /** To get survey details 
 * @class EventViewDetailsComponent
 * @method getSurveyID
 */
suveyTakenByUser(surveyId){
  this.timeOutError = false;
  this.SuveyTakenByUserDTO.surveyId = surveyId;
  this.SuveyTakenByUserDTO.userId = this.loginDetails.userId;

  this.eventService.suveyTakenByUser(this.SuveyTakenByUserDTO).subscribe(data =>{
    if(data != null){
      this.IsSurveyAlreadyTaken = data.userAlreadyTakenSurvey;
      if(this.IsSurveyAlreadyTaken)
     {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.DisableText = true;
      this.DisableRadio = true;
      this.alertDuplicateSurvey = true;
    //  localStorage.removeItem("eventIdforSurvey");
      setTimeout(() => {
        this.alertDuplicateSurvey = false;
        localStorage.removeItem('landingPage');
        localStorage.removeItem('paramaterId');
        if(this.eventDetails == null){
          this.router.navigate(['/site-home']);
        }
        else{
      this.router.navigate(['/event-view-details']);
          }  
      }, 3000);   
     }
     else{
      this.alertDuplicateSurvey = false;
     }

    }
  }, err => {
    this.spinner.hide();
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
                this.timeOutError = true;
              }
    });
}

  /** For Listing the Survey Questions and Answers details
  * @method listQuestionAnswers
  */

  listQuestionAnswers() {
    this.timeOutError = false;
    this.SurveyMaster = new SurveyMaster();
    this.SurveyMaster.surveyId = this.surveyId;
    this.SurveyMaster.surveyLaunchAdmin = this.surveyLaunchAdmin;
    this.SurveyMaster.eventId = this.eventId;

    this.eventService.getQuestionAnswers(this.SurveyMaster).subscribe(data => {

      if (data != null && data.length != 0) {
        this.spinner.hide();
        this.nameShow= true;
        this.questionsAndAnswersModel = data;
        /** For Assigning All Text type Of Questions to questionsText */
        this.questionsText = [];
        let b = [];
        let len = this.questionsAndAnswersModel.length;
        for (let i = 0; i < len; i++) {
          if (b.indexOf(this.questionsAndAnswersModel[i].surveyQuestion.surveyQuestionId) === -1) {

            b.push(this.questionsAndAnswersModel[i].surveyQuestion.surveyQuestionId);
            if ((this.questionsAndAnswersModel[i].surveyQuestion.answerType).replace(/\s/g, "") == 'TEXT') {
              this.questionsText.push(this.questionsAndAnswersModel[i]);
            }
          }
        }
        /** For Assigning All SELECT type Of Questions to questionsSelect */
        this.questionsSelect = [];
        let c = [];
        for (let i = 0; i < len; i++) {
          if (c.indexOf(this.questionsAndAnswersModel[i].surveyQuestion.surveyQuestionId) === -1) {

            c.push(this.questionsAndAnswersModel[i].surveyQuestion.surveyQuestionId);
            if ((this.questionsAndAnswersModel[i].surveyQuestion.answerType).replace(/\s/g, "") == 'SELECT') {
              this.questionsSelect.push(this.questionsAndAnswersModel[i]);
            }
          }
        }
      }
      else{
     //   localStorage.removeItem("eventIdforSurvey");
        this.spinner.hide();
        this.alertNoSurvey = true;
        setTimeout(() => {
          this.alertNoSurvey = false;
          this.router.navigate(['/event-view-details']);
        }, 1500);   
      }
    },
      err => {
        this.spinner.hide();
        console.log(JSON.stringify(err.value.message));
        if(err.value.statusText == ConstantValues.unknownError){
                    this.timeOutError = true;
                  }
      });
  }
  /** For Cancel the Survey Response
     * @class TakeSurveyComponent
     * @method cancel
     */
  cancel() {
    this.method = "cancelSurvey";
    this.msg1 = "Are you sure you want to cancel ?";
  }
  cancelSurvey() {
  //  localStorage.removeItem("eventIdforSurvey");
        if(this.eventDetails == null){
          localStorage.removeItem('landingPage');
          localStorage.removeItem('paramaterId');
            this.router.navigate(['/site-home']);
          }
          else{
        this.router.navigate(['/event-view-details']);
            }    
  }

  /** For submitting the Survey Response
     * @class TakeSurveyComponent
     * @method onSubmit
     */
  confirm() {
    this.method = "onSubmit";
    this.msg1 = "Are you sure you want to submit this Survey Form ?";
  }

  onSubmit() {
   // localStorage.removeItem("eventIdforSurvey");
  /** Preparing JSON request body For SELECT type Of Questions and Answers */
    for (var i = 0; i < this.selectedAnswer.length; i++) {
      var surveyAnswer = new SurveyAnswer();
      var surveyQuestion = new SurveyQuestion();
      surveyAnswer.answerId = this.selectedAnswer[i];
      surveyQuestion.surveyQuestionId = this.questionsSelect[i].surveyQuestion.surveyQuestionId;
      this.employee.userId = this.userId;
      let takeSurvey = new TakeSurvey();
      takeSurvey.comments = "none";
      takeSurvey.surveyId = this.surveyId;
      takeSurvey.surveyAnswer = surveyAnswer;
      takeSurvey.surveyQuestion = surveyQuestion;
      takeSurvey.employee = this.employee;
      takeSurvey.surveyResponseId = null;
      takeSurvey.surveyTakenUserName= this.optionalUserName;
      takeSurvey.createdBy = "1";
      takeSurvey.modifiedBy = "1";      
      this.takeSurveyList.push(takeSurvey);
    }

     /** Preparing JSON request body For TEXT type Of Questions and Answers */
    for (var i = 0 ; i <this.textAnswer.length; i++) {
      var surveyQuestion = new SurveyQuestion();
      surveyQuestion.surveyQuestionId = this.questionsText[i].surveyQuestion.surveyQuestionId;
      this.employee.userId = this.userId;
      let takeSurvey = new TakeSurvey();
      takeSurvey.comments = this.textAnswer[i];
      takeSurvey.surveyId = this.surveyId ;
      takeSurvey.surveyAnswer = null;
      takeSurvey.surveyQuestion = surveyQuestion;
      takeSurvey.employee = this.employee;
      takeSurvey.surveyResponseId = null;
      takeSurvey.surveyTakenUserName = this.optionalUserName ;
      takeSurvey.createdBy = "1";
      takeSurvey.modifiedBy = "1";      
      this.takeSurveyList.push(takeSurvey);
    }

    if (this.takeSurveyList.length != 0) {
      this.eventService.saveResponseSurvey(this.takeSurveyList).subscribe(data => {
        localStorage.removeItem('landingPage');
        localStorage.removeItem('paramaterId');
        this.spinner.hide();
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        this.alertSuccess = true;
        setTimeout(() => {
          if(this.eventDetails == null){
            this.router.navigate(['/site-home']);
          }
          else{
        this.router.navigate(['/event-view-details']);
            }       
        }, 6000);
      }, err => {
        this.spinner.hide();
        console.log(JSON.stringify(err.value.message));
        if(err.value.statusText == ConstantValues.unknownError){
                    this.timeOutError = true;
                  }
      })
    }
    
    else {
      this.router.navigate(['/event-view-details']);
      this.spinner.hide();
    }

  }
}







